<div *ngIf="returnOrdersEnabled$ | async">
  <agr-dropdown-button
    *ngIf="returnPackagingEnabled$ | async"
    [options]="dropdownOptions$ | async"
    [buttonText]="'app.start-return' | translate"
    data-test="return-button__dropdown"
    class="return-button__dropdown"
  />

  <button *ngIf="!(returnPackagingEnabled$ | async)" mat-flat-button color="accent" (click)="openReturnDialog()" data-test="return-button__single">
    <mat-icon>add</mat-icon>
    <span>{{ 'app.start-return' | translate }}</span>
  </button>
</div>
